<div class="progress-bar-container">
    <div class="progress-bar" [ngStyle]="{'width': progressInDecimals + '%'}">
    </div>
</div>
<div class="progress-tooltip" [ngStyle]="{'left': progressInDecimals + '%'}">
    {{progressInDecimals}}%
</div>
